import { useSelector } from 'react-redux';
import {
  isAdviserArea as selectIsAdvisorArea,
  isConsumerArea as selectIsConsumerArea,
} from '../../../CommonSelectors/CommonAreaSelector';
import { externalHostSelector as selectExternalHostSelector } from '../../../ConsumerArea/ConsumerAreaSelector';
import { isOptedIn } from '../../../CommonUtils/isOptedIn';
import { EXTERNAL_HOST } from '../../../ConsumerArea/ConsumerAreaConstants';

export const useShowAddGoal = () => {
  const isConsumer = useSelector(selectIsConsumerArea);

  const isAdvisor = useSelector(selectIsAdvisorArea);

  const isEditFinancialPlanOptedIn = isOptedIn('EditFinancialPlan');

  const externalHost = useSelector(selectExternalHostSelector);

  if (isEditFinancialPlanOptedIn) {
    if (isAdvisor) {
      return true;
    }

    if (isConsumer && externalHost !== EXTERNAL_HOST.FTCI) {
      return true;
    }
  }

  return false;
};
